import { cn } from '@/lib/utils';

type AlertVariant = 'info' | 'success' | 'warning' | 'danger';

const VARIANT_STYLES: Record<AlertVariant, string> = {
  info:    'border-brand-200 bg-brand-50 text-brand-800 dark:border-brand-900/40 dark:bg-brand-950/30 dark:text-brand-300',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-900/40 dark:bg-emerald-950/30 dark:text-emerald-300',
  warning: 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-200',
  danger:  'border-rose-200 bg-rose-50 text-rose-800 dark:border-rose-900 dark:bg-rose-950/40 dark:text-rose-300',
};

interface AlertBannerProps {
  variant?: AlertVariant;
  title?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

export function AlertBanner({ variant = 'info', title, children, icon, className }: AlertBannerProps) {
  return (
    <div className={cn('flex items-start gap-3 rounded-xl border p-4 text-sm', VARIANT_STYLES[variant], className)}>
      {icon && <span className="mt-0.5 shrink-0">{icon}</span>}
      <div>
        {title && <span className="font-semibold">{title} </span>}
        {children}
      </div>
    </div>
  );
}
